import { render, staticRenderFns } from "./HubSelect.vue?vue&type=template&id=1b54e1d1"
import script from "./HubSelect.vue?vue&type=script&lang=js"
export * from "./HubSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports